module.exports = __webpack_public_path__ + "img/ko.e3963e53.svg";